const DEFAULT_POLLING_INTERVAL_MS = 300;
const DEFAULT_STOP_POLLING_TIMEOUT_MS = 10_000;

interface MakeResolveInstanceOptions {
  interval?: number;
  timeout?: number;
  onTimeout?: () => void;
}

export const makeResolveInstance =
  <T>(
    getInstance: () => T | undefined,
    {
      interval = DEFAULT_POLLING_INTERVAL_MS,
      timeout = DEFAULT_STOP_POLLING_TIMEOUT_MS,
      onTimeout,
    }: MakeResolveInstanceOptions = {}
  ) =>
  (): Promise<T | undefined> => {
    if (getInstance()) return Promise.resolve(getInstance());

    return new Promise((resolve) => {
      let intervalId: NodeJS.Timeout | null = null;
      let timeoutId: NodeJS.Timeout | null = null;

      const cleanUp = () => {
        if (intervalId) clearInterval(intervalId);
        if (timeoutId) clearTimeout(timeoutId);
      };

      const handleInstanceResolution = () => {
        const instance = getInstance();
        if (instance) {
          cleanUp();
          resolve(instance);
        }
      };

      startPolling();

      function startPolling() {
        timeoutId = setTimeout(() => {
          onTimeout?.();
          cleanUp();
          resolve(undefined);
        }, timeout);

        intervalId = setInterval(handleInstanceResolution, interval);
      }
    });
  };
